import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentUser: null,
  isLoading: false,
  error: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearUser: (state) => {
      state.currentUser = null;
    },
    setUser: (state, action) => {
      state.currentUser = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Get User by ID
      .addCase('user/getUserById/pending', (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase('user/getUserById/fulfilled', (state, action) => {
        state.isLoading = false;
        state.currentUser = action.payload;
        state.error = null;
      })
      .addCase('user/getUserById/rejected', (state, action) => {
        state.isLoading = false;
        state.error = action.payload || 'Failed to fetch user';
      })
      // Update User
      .addCase('user/updateUser/pending', (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase('user/updateUser/fulfilled', (state, action) => {
        state.isLoading = false;
        state.currentUser = action.payload;
        state.error = null;
      })
      .addCase('user/updateUser/rejected', (state, action) => {
        state.isLoading = false;
        state.error = action.payload || 'Failed to update user';
      });
  },
});

export const { clearError, clearUser, setUser } = userSlice.actions;
export default userSlice.reducer;

